export interface NotificationRecipientSelectorView {
  kind?: string | number | null;
  entityId?: string | null;
  roleName?: string | null;
  emailAddress?: string | null;
}

export interface NotificationRecipientSelectorSave {
  kind: string;
  entityId?: string | null;
  roleName?: string | null;
  emailAddress?: string | null;
}

const KIND_BY_NUMBER: Record<number, string> = {
  0: 'User',
  1: 'Role',
  2: 'Organization',
  3: 'Region',
  4: 'Farm',
  5: 'Email',
};

export function looksLikeEmailAddress(value: string | null | undefined): boolean {
  const trimmed = (value ?? '').trim();
  return trimmed.includes('@') && !isGuidString(trimmed);
}

export function toRecipientSelectorDraft(item: NotificationRecipientSelectorView): {
  kind: string;
  entityId: string;
  roleName: string;
  emailAddress: string;
} {
  const saved = toRecipientSelectorSave({
    kind: namedRecipientKind(item.kind),
    entityId: item.entityId ?? '',
    roleName: item.roleName ?? '',
    emailAddress: item.emailAddress ?? '',
  });
  if (saved) {
    return {
      kind: saved.kind ?? 'User',
      entityId: saved.entityId ?? '',
      roleName: saved.roleName ?? '',
      emailAddress: saved.emailAddress ?? '',
    };
  }
  return {
    kind: namedRecipientKind(item.kind) || 'User',
    entityId: (item.entityId ?? '').trim(),
    roleName: (item.roleName ?? '').trim(),
    emailAddress: (item.emailAddress ?? '').trim(),
  };
}

export function toRecipientSelectorSave(row: {
  kind: string;
  entityId: string;
  roleName: string;
  emailAddress: string;
}): NotificationRecipientSelectorSave | null {
  const kind = namedRecipientKind(row.kind);
  const roleName = row.roleName.trim();
  const emailAddress = row.emailAddress.trim();
  const entityId = row.entityId.trim();

  if (kind === 'Role') {
    return roleName ? { kind: 'Role', roleName, entityId: null, emailAddress: null } : null;
  }

  if (kind === 'Email' || looksLikeEmailAddress(emailAddress) || looksLikeEmailAddress(entityId)) {
    const mailbox = emailAddress || entityId;
    return mailbox
      ? { kind: 'Email', emailAddress: mailbox, entityId: null, roleName: null }
      : null;
  }

  if (!entityId) {
    return null;
  }

  return {
    kind: kind || 'User',
    entityId,
    roleName: null,
    emailAddress: null,
  };
}

function namedRecipientKind(kind: string | number | undefined | null): string {
  if (typeof kind === 'number') {
    return KIND_BY_NUMBER[kind] ?? 'User';
  }
  const trimmed = (kind ?? '').trim();
  if (!trimmed) {
    return 'User';
  }
  if (/^\d+$/.test(trimmed)) {
    return KIND_BY_NUMBER[Number(trimmed)] ?? trimmed;
  }
  return trimmed;
}

function isGuidString(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}
